import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { pTicket } from '../../interfaces/pTicket';
import { MatFormField } from "@angular/material/form-field";
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { PTicketService } from '../../services/p-ticket.service';
import { openSnackBar } from '../../helpers/genericFunctions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-description-edit-initial-dialog',
  standalone: true,
  imports: [MatDialogModule, MatFormField, ReactiveFormsModule, MatInputModule, MatButtonModule],
  templateUrl: './description-edit-initial-dialog.component.html',
  styleUrl: './description-edit-initial-dialog.component.scss'
})
export class DescriptionEditInitialDialogComponent {
  constructor(
    private formBuilder: FormBuilder,
    private pTicketService: PTicketService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DescriptionEditInitialDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { ticket: pTicket; }
  ) { }


  editInitialDescriptionForm = this.formBuilder.group(
    {
      pticket_id: new FormControl(1, Validators.required),
      pct_initialdescription: new FormControl('', Validators.required),
    }
  );

  isLoading: boolean = false;

  ngOnInit(): void {
    this.editInitialDescriptionForm.patchValue({
      "pct_initialdescription" : this.data.ticket.pct_initialdescription
    })
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onTextareaKeydown(event: KeyboardEvent): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.onUpdateInitialDescription();
    }
  }
  onUpdateInitialDescription(): void {
    if (this.editInitialDescriptionForm.valid) {
      this.isLoading = true;
      this.pTicketService.update(this.data.ticket.id, {pct_initialdescription : this.editInitialDescriptionForm.controls.pct_initialdescription.value}).subscribe(
        response => {
          openSnackBar("Initial descripiton changed", 2000, this.snackBar);
          this.dialogRef.close(response);
          this.isLoading = false;
        },
        error => {
          openSnackBar("Error while changing initial descripiton" + error, 5000, this.snackBar);
          this.isLoading = false;
        }
      );
    }
  }
}
